import React, { useCallback, useState } from "react";

import { Box } from "@mui/material";
import { Tabs } from "@covertree/ui/table/Tabs";
import { TabPanel } from "@covertree/ui/table/TabPanel";
import {
  RenewalBaseFragment,
  RenewalWithCheckReceivalFragment,
} from "@covertree/agent-portal-graphql";
import { Documents } from "./Documents";
import { Overview } from "./Overview";

interface Props {
  renewal?: RenewalBaseFragment | RenewalWithCheckReceivalFragment;
  loading: boolean;
  error: boolean;
}

export function ContentTabs({ renewal, error, loading }: Props) {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = useCallback(
    (tabIndex: number) => {
      setActiveTab(tabIndex);
    },
    [setActiveTab]
  );

  return (
    <Box>
      <Tabs
        tabs={[
          { label: "Overview", value: "overview" },
          { label: "Documents", value: "documents" },
        ]}
        value={activeTab}
        onChange={handleChange}
        disabled={(!renewal && loading) || error}
        scrollButtons
        allowScrollButtonsMobile
      />
      <TabPanel value={activeTab} index={activeTab} py={3}>
        {activeTab === 0 && (
          <Overview renewal={renewal} loading={loading} error={error} />
        )}
        {activeTab === 1 && <Documents renewal={renewal} loading={loading} />}
      </TabPanel>
    </Box>
  );
}
